import { render, staticRenderFns } from "./ExamAttributeTypeText.vue?vue&type=template&id=2d91db5c&scoped=true&"
import script from "./ExamAttributeTypeText.vue?vue&type=script&lang=ts&"
export * from "./ExamAttributeTypeText.vue?vue&type=script&lang=ts&"
import style0 from "./ExamAttributeTypeText.vue?vue&type=style&index=0&id=2d91db5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d91db5c",
  null
  
)

export default component.exports